import React from "react";
import about_Data from "../../Data/selectCity (1).json";
import styles from "../About/About.module.css";

const About = () => {
  // retrieving json data
  const aboutjsondata = about_Data[0]?.banner4;
  return (
    <div className={styles.container}>
      <div className={styles.about}>
        <h3>{aboutjsondata.title}</h3>
        <p>{aboutjsondata.description}</p>
      </div>
      <div className={styles.images}>
        {aboutjsondata.imgs.map((elem, ind) => {
          return (
            <>
              <img src={elem} alt={elem} key={elem} />
            </>
          );
        })}
      </div>
    </div>
  );
};

export default About;
